import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar25Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar25 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar25Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar25">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <G id="Group_2">
            <Path
              id="skin"
              d="M169.999 51.005c-77.974-1.096-60.379 77.625-60.18 79.936-9.302-7.578-23.592-.429-18.477 20.01 8.706 34.817 26.389 25.507 33.443 20.47 2.534 5.95-5.934 47.177-6.697 54.152-2.081 19.08-20.581 25.634-20.581 25.634s37.573 37.914 77.791 50.711a150.258 150.258 0 0 0 23.918-5.624c2.701-14.163 2.256-40.822-18.35-44.928-3.241-.644-.309-21.766.358-33.538 8.237 1.565 18.032 4.027 24.299-2.24 6.522-13.663 20.503-40.703 21.194-52.674.444-7.745-.882-10.668-.882-24.863.683-46.248-18.755-86.53-55.844-87.054l.008.008Z"
              fill={c.skin}
            />
            <Path
              id="Vector"
              opacity={0.75}
              d="M179.254 236.893c.754-6.919 2.653-19.113 2.24-19.2-22.29-4.981-36.874-14.124-42.181-19.041 0 .453 12.702 32.728 39.941 38.241Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_2"
              opacity={0.75}
              d="M174.194 180.453c.699.85 10.231 16.102 22.155 16.467 10.16.31 14.322-11.343 14.608-11.931 0 0-4.091-5.465-7.213-5.561-3.122-.095-5.433 1.581-5.433 1.581s-2.653-2.216-5.966-2.319c-3.312-.104-6.41 1.747-9.556 2.137-3.177.397-8.603-.374-8.603-.374h.008Zm4.115 2.637c-.08-.063 0-.174.095-.127 3.662 1.915 10.152 3.511 20.359 3.821 5.259.159 8.746.215 11.701-.715-2.963 1.2-7.022 4.735-12.273 4.576-10.239-.31-16.316-4.87-19.89-7.563l.008.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_3"
              opacity={0.75}
              d="M191.098 167.426c-.604 2.351 2.304 3.908 12.281 3.511 8.214-.326 10.867-4.782 9.254-5.409-1.612-.628-3.773 2.176-9.119 2.176-7.8 0-11.804-2.629-12.408-.278h-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_4"
              d="M144.684 126.914s12.765-4.012 22.695-3.94c11.669.087 19.859 7.896 22.107 3.9.715-1.271.23-7.952-21.035-10.136-9.516-.977-15.116 3.487-23.767 10.184v-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_5"
              d="M185.418 142.317c-2.875-4.917-7.65-9.453-13.639-10.549-2.701-.318-5.425-.016-7.991.985-2.097.802-3.718 2.129-5.275 3.463-2.113 1.462-4.909.906-7.443.604 2.399 1.676 5.942 3.019 8.857 1.581a27.86 27.86 0 0 1 2.026-1.184c-.016.215-.04.421-.04.636 0 3.908 3.281 7.085 7.324 7.085 4.043 0 7.324-3.169 7.324-7.085 0-.318-.032-.636-.071-.946 2.867 1.319 5.759 3.265 8.928 5.41Z"
              fill="#000"
            />
            <Path
              id="Vector_6"
              d="M224.747 119.893c-13.949-.422-21.979 7.316-20.486 10.191.929 1.779 3.773 1.851 5.87-.159 5.759-4.941 9.191-3.288 15.22-3.368-.111-2.105-.413-4.909-.612-6.664h.008Z"
              fill="#000"
            />
            <G id="Group_3" fill="#000">
              <Path
                id="Vector_7"
                d="M98.365 250.626c-16.666 3.329-34.054 8.603-47.042 14.998 26.778 23.672 61.96 38.042 100.51 38.042 7.729 0 15.323-.58 22.743-1.7-30.504-11.225-70.158-45.938-76.211-51.34Z"
              />
              <Path
                id="Vector_8"
                d="M240.984 274.553a22.407 22.407 0 0 0-2.248-1.772c-10.891-7.467-32.498-17.587-61.539-22.695.222.588 3.36 3.472 3.725 3.551 20.058 4.155 20.272 29.741 17.468 43.722 15.45-5.211 29.797-12.972 42.586-22.806h.008Z"
              />
            </G>
            <Path
              id="hair"
              d="M154.406 42.64c-15.156-4.837-54.135-1.707-77.672 45.692-18.62 37.502-28.978 132.563-32.489 170.628a152.95 152.95 0 0 0 12.098 10.907c20.383-8.103 57.027-23.577 60.037-31.219 4.195-10.636 10.542-60.871 8.738-67.131-.492-1.715-22.885 21.488-33.672-22.337-5.029-12.71 9.699-39.019 32.441 1.851 2.614 4.702 4.385-24.157 3.622-25.57-.762-1.414 16.873-7.785 26.008-21.599 9.135-13.806 14.616-23.14 32.894-30.757-.421-3.432-11.51-17.897-11.51-17.897s52.332 29.113 50.624 80.087c-.691 17.245.064 21.002-.453 28.517-1.644 7.801-17.15 45.707-21.026 51.458-3.869 5.752-22.814 2.503-22.814 2.503l-4.004 32.314 55.391 30.329a154.905 154.905 0 0 0 6.458-4.298c2.224-10.461 5.147-32.688.04-65.034 9.746-45.993 8.531-184.592-84.679-168.451l-.032.008Z"
              fill={c.hair}
            />
            <Path
              id="Vector_9"
              d="M230.776 138.759c-1.557-1.327-3.17-2.662-5.275-3.464-2.565-.993-5.298-1.303-7.991-.985-5.989 1.096-10.755 5.632-13.639 10.549 1.629-1.096 3.185-2.152 4.695-3.09.278 3.44 3.249 6.149 6.879 6.149 3.813 0 6.911-2.987 6.911-6.681a6.4 6.4 0 0 0-1.001-3.416c2.47.278 5.092 1.232 8.007 3.114 2.915 1.438 6.458.095 8.857-1.581-2.534.294-5.338.85-7.443-.603v.008Z"
              fill="#000"
            />
          </G>
          <Path
            id="accessories"
            d="M234.265 123.903c-20.257-2.55-28.256 3.352-31.378 7.793-.921-.731-2.208-1.509-3.598-1.509-1.39 0-2.907.73-3.869 1.318-4.122-4.718-12.018-7.721-23.52-8.928-10.208-1.073-20.709-.461-26.055 0a3.465 3.465 0 0 0-1.796.675h-.198l-41.021 4.107a1.588 1.588 0 0 0 .159 3.169h.159l39.202-3.924a7.378 7.378 0 0 0 .031 1.668c1.224 9.374 16.475 33.983 31.687 34.904.31.016.62.032.93.032 9.762 0 17.174-9.596 22.043-28.533l.127-.485c.707-.421 1.557-.81 2.137-.81.54 0 1.414.604 2.057 1.199l-.016.04.08.453c3.122 17.809 7.848 26.476 14.441 26.476h.326c10.485-.445 20.065-24.689 20.748-32.323.271-2.978-.778-5.068-2.653-5.298l-.023-.024Zm-60.014 36.088c-13.599-.826-27.747-24.633-28.732-32.148-.127-.937.064-1.66.294-1.954a.351.351 0 0 1 .294-.151c35.333-3.026 45.167 5.354 47.661 8.81-3.193 12.122-9.119 26.047-19.525 25.443h.008Zm59.505-31.067c-.683 7.617-10.104 29.105-17.714 29.431h-.151c-2.725 0-7.658-3.162-11.264-23.378 4.647-10.001 22.949-8.683 28.97-7.96.111.286.246.945.159 1.899v.008Z"
            fill={c.accessories}
          />
        </G>
      </G>
    </Svg>
  );
};
